<template>
	<div class="social-connect">
			<a class="social-btn social-btn--google" @click="socialClickHandler('Google')">SIGN IN WITH GOOGLE</a>
	</div>
</template>

<script>
	export default {
		methods: {
			socialClickHandler(src) {
				this.$emit('socialButtonClick');
				let url = CognitoHostedInterfaceURL + '/oauth2/authorize?identity_provider=' + src + '&redirect_uri=' + CognitoAuthRedirectURL + '&response_type=TOKEN&scope=openid%20aws.cognito.signin.user.admin&client_id=' + CognitoClientIdPlayfootball;
				return window.location = url;
			}
		}
	};
</script>

<style lang="scss" scoped>
	@import "~sass/_config.scss";
	@import "~sass/_variables.scss";
	@import "~sass/mixins/_media-query.scss";

	.social-connect {
		display: flex;
		justify-content: center;
		margin-bottom: 40px;

		@include maxq(mobile) {
			flex-wrap: wrap;
		}
	}
</style>
